import { onErrorShowMessage } from '~src/errors';
import { getAxiosClient } from '~src/api';

export const fetchGiottoProducts = async () => {
  try {
    const http = await getAxiosClient(true, 3);
    const url = `${process.env.GIOTTO_API_URL}/products`;
    const { data } = await http.get(url, { responseType: 'json' });

    const categories = Array.isArray(data?.categories)
      ? data.categories
      : Array.isArray(data)
      ? data
      : [];

    const normalizeString = (v) => (typeof v === 'string' ? v : v ?? '');

    const normalized = categories.map((cat) => {
      const objectId =
        cat.objectId || cat.id || cat.categoryId || normalizeString(cat.key);
      const name = normalizeString(cat.name || cat.nome || cat.title);
      const order = typeof cat.order === 'number' ? cat.order : cat.ordine ?? 0;
      let rawItems = Array.isArray(cat.items)
        ? cat.items
        : Array.isArray(cat.products)
        ? cat.products
        : Array.isArray(cat.prodotti)
        ? cat.prodotti
        : [];

      // Support nested connection shape: items.edges -> node
      if (
        !Array.isArray(rawItems) &&
        cat.items &&
        Array.isArray(cat.items.edges)
      ) {
        rawItems = cat.items.edges.map((e) => e && e.node).filter(Boolean);
      }

      const items = rawItems
        .filter(Boolean)
        .map((p) => {
          // If already in expected shape: keep as-is
          if (
            p &&
            p.product_pointer &&
            (p.product_pointer.objectId || p.product_pointer.id)
          ) {
            const pp = p.product_pointer;
            const objectId = pp.objectId || pp.id;
            const nome = pp.nome || pp.name || '';
            const org = pp.org_pointer || pp.org || {};
            const orgId = org?.objectId || org?.id;
            const orgName = org?.nome || org?.name || '';
            const imgUrl = pp?.img?.url || pp?.imgUrl || pp?.imageUrl || null;
            return {
              product_pointer: {
                objectId,
                nome,
                org_pointer: { objectId: orgId, nome: orgName },
                ...(imgUrl ? { img: { url: imgUrl } } : {}),
              },
            };
          }
          // If API returns item.product or item.servizio as the product entity
          const prod = p?.product || p?.servizio || p?.service || null;
          if (prod && (prod.objectId || prod.id)) {
            const objectId = prod.objectId || prod.id;
            const nome = prod.nome || prod.name || '';
            const org = prod.org_pointer || prod.org || {};
            const orgId = org?.objectId || org?.id;
            const orgName = org?.nome || org?.name || '';
            const imgUrl =
              prod?.img?.url || prod?.imgUrl || prod?.imageUrl || null;
            return {
              product_pointer: {
                objectId,
                nome,
                org_pointer: { objectId: orgId, nome: orgName },
                ...(imgUrl ? { img: { url: imgUrl } } : {}),
              },
            };
          }
          const pid = p?.objectId || p?.id || p?.productId;
          const pname = p?.nome || p?.name || '';
          const org = p?.org || p?.org_pointer || {};
          const orgId = org?.objectId || org?.id;
          const orgName = org?.nome || org?.name || '';
          const imgUrl = p?.img?.url || p?.imgUrl || p?.imageUrl || null;
          return {
            product_pointer: {
              objectId: pid,
              nome: pname,
              org_pointer: { objectId: orgId, nome: orgName },
              ...(imgUrl ? { img: { url: imgUrl } } : {}),
            },
          };
        })
        // filter out items that still miss an id or name
        .filter(
          (it) => it?.product_pointer?.objectId && it?.product_pointer?.nome
        );

      return { objectId, name, order, items };
    });

    return normalized;
  } catch (error) {
    onErrorShowMessage();
    console.error('Failed to fetch products from GIOTTO API', error);
    return [];
  }
};
